import type { FunctionComponent } from 'react';

import { ModalContainer } from '@kanda-libs/ks-component-ts';
import type {
  FinanceProvider,
  FinanceRate,
} from '@kanda-libs/ks-frontend-services';

import CustomRatesModalForm from './CustomRatesModalForm';

import { MODAL_ID } from '../constants';

export interface CustomRatesModalProps {
  allRates: FinanceRate[];
  existing: FinanceRate[] | null;
  hasExisting: boolean;
  providersRequiringUserId: FinanceProvider[];
  isLoading: boolean;
}

const CustomRatesModal: FunctionComponent<CustomRatesModalProps> = function ({
  allRates,
  existing,
  hasExisting,
  providersRequiringUserId,
  isLoading,
}) {
  return (
    <ModalContainer id={MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <CustomRatesModalForm
          handleClose={handleClose}
          ref={ref}
          allRates={allRates}
          existing={existing}
          hasExisting={hasExisting}
          providersRequiringUserId={providersRequiringUserId}
          isLoading={isLoading}
        />
      )}
    </ModalContainer>
  );
};

export default CustomRatesModal;
